import { CLINIC_SUBSCRIPTION_PATH } from "@/domains/multi/clinicMemberPaths";
import {
    isTherapistPaymentSetupPath,
    requiresPaymentBeforeAccess,
} from "@/domains/subscription/accountAccess";
import { useAuth } from "@/domains/shared/hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router";

/** Redirects therapists with pending Pro/Pro+ signup payment to Assinatura. */
export default function PendingPaymentGuard() {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="h-10 w-10 border-2 border-border border-t-primary rounded-full animate-spin" />
            </div>
        );
    }

    if (user && requiresPaymentBeforeAccess(user)) {
        if (!isTherapistPaymentSetupPath(location.pathname)) {
            return <Navigate to={CLINIC_SUBSCRIPTION_PATH} replace />;
        }
    }

    return <Outlet />;
}
